
import { useState, useEffect } from 'react';
import { Business } from '@/data/types/businessTypes';

export const useCalendarState = (business: Business | null) => {
  // Calendar state
  const [calendarOpen, setCalendarOpen] = useState(false);
  const [date, setDate] = useState<Date | undefined>(undefined);
  
  // Set date for calendar if openingDate exists
  useEffect(() => {
    if (business?.openingDate || business?.founded) {
      try {
        const dateValue = business.openingDate || business.founded || '';
        const parsedDate = new Date(dateValue);
        
        // Check if the date is valid
        if (!isNaN(parsedDate.getTime())) {
          setDate(parsedDate);
        }
      } catch (e) {
        console.error("Invalid date format:", business.openingDate || business.founded);
      }
    }
  }, [business]);

  return {
    calendarOpen,
    setCalendarOpen,
    date,
    setDate
  };
};
